import { getLocalParticipant } from '../participants/functions';
import StateListenerRegistry from '../redux/StateListenerRegistry';
import { isLocalTrackMuted } from '../tracks';
import { MEDIA_TYPE } from './constants';
/**
 * Notifies when the local audio mute state changes.
 */
StateListenerRegistry.register(
/* selector */ (state) => state['features/base/media'].audio.muted, 
/* listener */ (muted, store, previousMuted) => {
    if (typeof APP !== 'object') {
        return;
    }
    if (muted !== previousMuted) {
        APP.API.notifyAudioMutedStatusChanged(muted);
        // Also fire the participantMuted event for consistency
        const localParticipant = getLocalParticipant(store.getState());
        if (localParticipant) {
            APP.API.notifyParticipantMuted(localParticipant.id, muted, 'audio');
        }
    }
});
/**
 * Notifies when the local video mute state changes.
 */
StateListenerRegistry.register(
/* selector */ state => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.VIDEO), 
/* listener */ (muted, store, previousMuted) => {
    if (muted !== previousMuted) {
        if (typeof APP !== 'object') {
            return;
        }
        APP.API.notifyVideoMutedStatusChanged(muted);
        // APP.API.notifyVideoAvailabilityChanged(available);
        // Also fire the participantMuted event for consistency
        const localParticipant = getLocalParticipant(store.getState());
        if (localParticipant) {
            APP.API.notifyParticipantMuted(localParticipant.id, muted, 'video');
        }
    }
});
